import React from 'react';
import { useGetDta } from '../../hooks/useGetDta';
import LoadinSpin from '../ui/LoadinSpin';

const InfoCliente = ({ id }) => {
    const { loading, data } = useGetDta(`user/us/${id}`);
    let { loading: load, data: ser } = useGetDta(`user/services/${id}`);

    if (loading || load) return <LoadinSpin />;

    return (
        <div className='p-2'>
            <div>
                <span>
                    <b>Cliente:</b>
                    {data.nombre}
                </span>
                <br />
                <span>
                    <b>Dirección Principal:</b>
                    {data.direccion_principal}
                </span>
                <br />
                <span>
                    <b>Teléfono :</b>
                    {data.telefono}
                </span>
                <br />
                <span>
                    <b>Móvil :</b>
                    {data.movil}
                </span>
            </div>
            <div className="overflow-x-auto relative">
                <table className='table'>
                    <thead className="text-xs text-uppercase ">
                        <tr>
                            <th>Plan</th>

                            <th>Instalado</th>
                            <th>Ip</th>
                            <th>Router</th>
                            <th>Dirección</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ser.map((se) => (
                            <tr className="bg-white border-b" key={se.nodo}>
                                <th scope="row" className="py-4 px-6 font-medium  whitespace-nowrap ">
                                    {se.plan}
                                </th>
                                <td className="py-4 px-6">{se.instalado}</td>
                                <td className="py-4 px-6">{se.redIpv4}</td>
                                <td className="py-4 px-6">{se.nodo}</td>
                                <td className="py-4 px-6">{se.direccion}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default InfoCliente;
